import {IUiActions, SET_BOTTOM_FIXED_ELEMENT_HEIGHT, SET_PROPERTY_BUY_REWARD_BANNER_VISIBILITY} from "../actions/ui_actions";

/*
 * INFO: Please use this reducer as the last resort - we should store UI data in Redux only when there is no better solution and
 * there is a need to pass props on many levels.
 */
export interface IUiStore {
    /*
     * On some views (e.g. property, offer) we have several components located at the bottom of the screen.
     * The components do not know about each other - so we need to measure the height of the lowest component - in order to
     * correctly position the other components.
     */
    bottomFixedElementHeight: number | null;
    propertyBuyRewardBannerVisibility: boolean;
}

export const uiReducer = (state: IUiStore = {bottomFixedElementHeight: null, propertyBuyRewardBannerVisibility: false}, action: IUiActions): IUiStore => {
    switch (action.type) {
        case SET_BOTTOM_FIXED_ELEMENT_HEIGHT: {
            return {
                ...state,
                bottomFixedElementHeight: action.value as number | null
            };
        }
        case SET_PROPERTY_BUY_REWARD_BANNER_VISIBILITY: {
            return {
                ...state,
                propertyBuyRewardBannerVisibility: action.value as boolean
            };
        }
        default:
            return state;
    }
};
import {IUiActions, SET_BOTTOM_FIXED_ELEMENT_HEIGHT, SET_PROPERTY_BUY_REWARD_BANNER_VISIBILITY} from "../actions/ui_actions";

/*
 * INFO: Please use this reducer as the last resort - we should store UI data in Redux only when there is no better solution and
 * there is a need to pass props on many levels.
 */
export interface IUiStore {
    /*
     * On some views (e.g. property, offer) we have several components located at the bottom of the screen.
     * The components do not know about each other - so we need to measure the height of the lowest component - in order to
     * correctly position the other components.
     */
    bottomFixedElementHeight: number | null;
    propertyBuyRewardBannerVisibility: boolean;
}

export const uiReducer = (state: IUiStore = {bottomFixedElementHeight: null, propertyBuyRewardBannerVisibility: false}, action: IUiActions): IUiStore => {
    switch (action.type) {
        case SET_BOTTOM_FIXED_ELEMENT_HEIGHT: {
            return {
                ...state,
                bottomFixedElementHeight: action.value as number | null
            };
        }
        case SET_PROPERTY_BUY_REWARD_BANNER_VISIBILITY: {
            return {
                ...state,
                propertyBuyRewardBannerVisibility: action.value as boolean
            };
        }
        default:
            return state;
    }
};
